import { InternalAxiosRequestConfig } from "axios";
import { SessionClient } from "../../../domain/clients";

export const createAuthInterceptor = (sessionClient: SessionClient) => {
  return (config: InternalAxiosRequestConfig) => {
    const accessToken = sessionClient.getAuthToken();
    if (accessToken) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  };
};
